import { FormEvent, useState } from 'react';
import LiveDetailDialog from '../LiveList/Component/LiveDetailDialog';
import { AdminActionButton } from '../../../Component/UI/AdminPageHeader';
import api from '../../../Component/axios_Interceptor/api';
import { SERVER_ADDRESS } from '../../../Component/server';
import { productRequestError } from '../LiveList/productRequestError';
import TaxExemptCheckbox from '../../../Component/UI/TaxExemptCheckbox';

export type WarehouseEditableProduct = {
  seq: number; name: string; product_num: string; price: number; product_description?: string;
  is_pg?: boolean; is_tax_exempt?: boolean; individual_delivery?: boolean; individual_delivery_price?: number;
  payment_mode?: string | null; product_status?: string;
};
export default function WarehouseProductEditDialog({ product, onClose, onSaved }: {
  product: WarehouseEditableProduct; onClose: () => void; onSaved: () => void;
}) {
  const [draft, setDraft] = useState({ name: product.name, product_num: product.product_num || '', price: String(product.price),
    product_description: product.product_description || '', is_pg: product.is_pg !== false, is_tax_exempt: !!product.is_tax_exempt,
    individual_delivery: !!product.individual_delivery, individual_delivery_price: String(product.individual_delivery_price || 0) });
  const [saving, setSaving] = useState(false), [error, setError] = useState('');
  const submit = async (event: FormEvent) => {
    event.preventDefault(); if (saving) return;
    setSaving(true); setError('');
    try {
      await api.patch(`${SERVER_ADDRESS}product/warehouse/products/${product.seq}`, { ...draft,
        price: Number(draft.price), individual_delivery_price: Number(draft.individual_delivery_price) });
      onSaved();
    } catch (reason) { setError(productRequestError(reason, '상품을 수정하지 못했습니다.')); }
    finally { setSaving(false); }
  };
  return <LiveDetailDialog open title="상품 상세 수정" size="medium" width={720} closeOnlyByButton={saving} onClose={() => { if (!saving) onClose(); }}>
    <form className="warehouse-edit-form" onSubmit={submit}>
      <div className="warehouse-edit-fields">
        <label>상품명<input aria-label="창고 상품명" value={draft.name} maxLength={255} required disabled={saving}
          onChange={event => setDraft({ ...draft, name: event.target.value })} /></label>
        <label>상품 코드<input aria-label="창고 상품 코드" value={draft.product_num} maxLength={255} disabled={saving}
          onChange={event => setDraft({ ...draft, product_num: event.target.value })} /></label>
        <label>금액<div className="warehouse-currency"><input aria-label="창고 금액" type="number" min={0} max={2147483647} step={1} required value={draft.price} disabled={saving}
          onChange={event => setDraft({ ...draft, price: event.target.value })} /><span>원</span></div></label>
        <div className="warehouse-edit-policies">
          {(!product.payment_mode || product.payment_mode === 'combined') && <AdminActionButton type="button" aria-label="창고 PG 여부" aria-pressed={draft.is_pg} $accented={draft.is_pg} disabled={saving}
            onClick={() => setDraft({ ...draft, is_pg: !draft.is_pg })}>{draft.is_pg ? 'PG' : '무통장'}</AdminActionButton>}
          <TaxExemptCheckbox label="창고 면세 여부" checked={draft.is_tax_exempt} disabled={saving}
            onChange={checked => setDraft({ ...draft, is_tax_exempt: checked })} />
        </div>
        <section className="warehouse-edit-delivery"><AdminActionButton type="button" $accented={draft.individual_delivery} aria-pressed={draft.individual_delivery} disabled={saving}
          onClick={() => setDraft({ ...draft, individual_delivery: !draft.individual_delivery })}>개별 배송</AdminActionButton>
          {draft.individual_delivery && <label>개별 배송비<div className="warehouse-currency"><input aria-label="창고 개별 배송비" type="number" min={0} max={2147483647} step={1} required value={draft.individual_delivery_price} disabled={saving}
            onChange={event => setDraft({ ...draft, individual_delivery_price: event.target.value })} /><span>원</span></div></label>}
        </section>
        <label className="warehouse-edit-description">상품 설명<textarea aria-label="창고 상품 설명" maxLength={255} rows={3} value={draft.product_description} disabled={saving}
          onChange={event => setDraft({ ...draft, product_description: event.target.value })} /></label>
      </div>
      {error && <p role="alert" className="warehouse-error">{error}</p>}
      <div className="warehouse-edit-footer"><AdminActionButton type="button" disabled={saving} onClick={onClose}>닫기</AdminActionButton><AdminActionButton $primary type="submit" disabled={saving}>{saving ? '저장 중…' : '저장'}</AdminActionButton></div>
    </form>
  </LiveDetailDialog>;
}
